/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TargetMeasureRequestDto { 
    /**
     * Reference to observation type from Observation Service. Should use LOINC codes where applicable.
     */
    observationType: string;
    /**
     * Target value or threshold
     */
    targetValue: string;
    /**
     * Comparison operator for target evaluation
     */
    targetOperator: TargetMeasureRequestDto.TargetOperatorEnum;
    /**
     * Unit of measurement
     */
    unit?: string;
    /**
     * Expected observation frequency
     */
    frequency?: string;
}
export namespace TargetMeasureRequestDto {
    export type TargetOperatorEnum = '<' | '<=' | '>' | '>=' | '=' | 'between';
    export const TargetOperatorEnum = {
        LessThan: '<' as TargetOperatorEnum,
        LessThanOrEqualTo: '<=' as TargetOperatorEnum,
        GreaterThan: '>' as TargetOperatorEnum,
        GreaterThanOrEqualTo: '>=' as TargetOperatorEnum,
        Equal: '=' as TargetOperatorEnum,
        Between: 'between' as TargetOperatorEnum
    };
}


